export default {"src":"/_next/static/media/integration-ux-ui-mappings.abe64c68.svg","height":349,"width":422,"blurWidth":0,"blurHeight":0};